export default {
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  }
};